import { defineMessages } from "react-intl";

import TourDescriptor from "@app/component/flows/types/TourDescriptor";

const messages = defineMessages({
  performance1: {
    id: "guides.gettingStarted.checklist.performance.step1",
    defaultMessage: "Stack rank",
  },
  performance1Description: {
    id: "guides.gettingStarted.checklist.performance.step1.description",
    defaultMessage:
      "Here you can see how you are comparing to other members of your team for different metrics.",
  },
  performance2: {
    id: "guides.gettingStarted.checklist.performance.step2",
    defaultMessage: "Dashboard",
  },
  performance2Description: {
    id: "guides.gettingStarted.checklist.performance.step2.description",
    defaultMessage:
      "Within the Dashboard you can see different charts and graphs that have been configured by your admin or manager based on certain MMC fields and metrics.",
  },
});

export const repsPerformanceTour: TourDescriptor = {
  id: "getting-started-reps-performance",
  steps: [
    {
      id: "stack-rank",
      description: messages.performance1Description,
      position: "right",
      selector: "[class*=ScopeList_container]",
      title: messages.performance1,
    },
    {
      id: "dashboard",
      description: messages.performance2Description,
      selector: "div[class*=DashboardTabs_tab] [data-node-key=dashboard]",
      title: messages.performance2,
    },
  ],
};
